export const codeNoticeEquals = (error, text) => error === text
